import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=9a15c298&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=9a15c298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a15c298",
  null
  
)

export default component.exports